import { Color } from '@angular-material-components/color-picker';

export class GeneralUtilities {


  static colorNameToHex(colorName: string): any {
    //return color name to hex
    let tempElem = document.createElement('div');
    tempElem.style.color = colorName;
    document.body.appendChild(tempElem);
    let color = window.getComputedStyle(tempElem).color;
    document.body.removeChild(tempElem);
    return color;
  }

  static hexToRgb(_fillColor: string): string {
    const color = GeneralUtilities.hexToColor(_fillColor);
    return `rgb(${color.r}, ${color.g}, ${color.b})`;
  }

  static hexToColor(hex): Color {
    try {
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? new Color(
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16)
          )
        : null;
    } catch (error) {
      return null;
    }
  }

  static hexToHSL(hex): any {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    let r = parseInt(result[1], 16);
    let g = parseInt(result[2], 16);
    let b = parseInt(result[3], 16);

    (r /= 255), (g /= 255), (b /= 255);
    let max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h: number = (max + min) / 2;
    let s: number = (max + min) / 2;
    let l: number = (max + min) / 2;

    if (max === min) {
      h = s = 0; // achromatic
    } else {
      let d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    s = s * 100;
    s = Math.round(s);
    l = l * 100;
    l = Math.round(l);
    h = Math.round(360 * h);

    let HLS = new Object();
    HLS['h'] = h + 'deg';
    HLS['s'] = s + '%';
    HLS['l'] = l + '%';

    return HLS;
    //let colorInHSL = 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
    //return colorInHSL;
  }

  static hslToHex(h, s, l) {
    l /= 100;
    const a = (s * Math.min(l, 1 - l)) / 100;
    const f = (n) => {
      const k = (n + h / 30) % 12;
      const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return Math.round(255 * color)
        .toString(16)
        .padStart(2, '0'); // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
  }

  static lightenRGBcolor(color: string, percentage: number) {
    if (!color) return color; // If the color is not in RGB format, return it as is
    if (color.includes('#')) {
      color = GeneralUtilities.hexToRgb(color);
    }

    // Convert the input color string to an array of RGB values
    let colorArray = color.match(/\d+/g).map(Number);

    // Loop through the RGB values and increase each value by the percentage
    for (let i = 0; i < colorArray.length; i++) {
      colorArray[i] += (255 - colorArray[i]) * (percentage / 100);
    }

    // Return the lightened color as an RGB string
    return `rgb(${colorArray[0]}, ${colorArray[1]}, ${colorArray[2]})`;
  }

  static toUpperCase(obj: Record<string, any> | string): Record<string, any> | string {
    //if obj is a string, convert it to pascal case string and return
    if (typeof obj === 'string') {
      return obj.toUpperCase();
    }

    const result: Record<string, any> = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        const pascalKey = key.toUpperCase();
        result[pascalKey] = value;
      }
    }

    return result;
  }



  static camelToPascalCase(obj: Record<string, any> | string): Record<string, any> | string {
    //if obj is a string, convert it to pascal case string and return
    if (typeof obj === 'string') {
      return obj.charAt(0).toUpperCase() + obj.slice(1);
    }

    const result: Record<string, any> = {};

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
        result[pascalKey] = value;
      }
    }

    return result;
  }

  static containsSearchText(entity: any, searchFilter: string) {
    if (!searchFilter) return true;

    const searchText = searchFilter.toLowerCase();
    return Object.values(entity).some((value) => {
      if (value) {
        return value.toString().toLowerCase().includes(searchText);
      }
      return false;
    });
  }

  static formatMoney(value : number) {
    if (!value) return '';
    return '$' + (Math.round(value * 100) / 100).toFixed(2);
  }

}
